export const state = {
    show: true,
    navItems: [
        {
            icon: "mdi-home",
            title: "الرئيسية",
            link: "/dashboard",
            code: 1000,

        },
        {
           icon: "mdi-calendar-plus",
           title: "حجز مباشر ",
           link: "/bookPatients",
           code: 3006,
       },
        {
            icon: "mdi-calendar-today-outline",
            title: "قفل العمل اليومي",
            link: "/workDaysClosing",
            code: 28000,
        }, 
        {
            icon: "mdi-account-details-outline",
            title: "الاستعلامات",
            link: "/patients",
            code: 2000,
        },
        {
            icon: "mdi-calendar-month-outline",
            title: "حجز المواعيد",
            link: "/appointments",
            code: 3000,

        },

        {
            icon: "mdi-cash-clock",
            title: "الخزينة",
            link: "/treasury",
            code: 4000,

        },
        {
            icon: "mdi-calendar-account-outline",
            title: "حجوزات الاطباء",
            link: "/doctorsAppointments",
            code: 6000,
        },
        {
            icon: "mdi-account-group",
            title: "ادارة سجلات المرضي ",
            link: "/patientsProcedures",
            code: 5000,
        },
        {
            icon: "mdi-invoice-list-outline",
            title: "ادارة الفواتير",
            link: "/invoices",
            code: 24000,

        },
        {
            icon: "mdi-needle",
            title: "التحاليل الطبية",
            link: "/invoicesAnalysis",
            code: 23000,
        },
        {
            icon: "mdi-order-bool-ascending",
            title: "الوصفة الطبية",
            link: "/doctorPrescriptions",
            code: 27000,
        },


        {
            icon: "mdi-doctor",
            title: "الاطباء",
            link: "/doctors",
            code: 11000,
        }, 
        {
            icon: "mdi-store-check-outline",
            title: "مخزون الاطباء ",
            link: "/doctorsStock",
            code: 31000,
        },
        {
            icon: "mdi-account-multiple-outline",
            title: "الموظفين",
            link: "/employees",
            code: 10000,
        },
        // {
        //     // icon: "mdi-file-sign",
        //     icon: "mdi-file-cog-outline",
        //     title: "إدارة المخزون ",
        //     group: "inventoryManagement",
        //     codes: [19000],

        //     subNavs: [
        //         {
        //             icon: "mdi-badge-account-outline",
        //             title: "الموردين",
        //             link: "/suppliers",
        //             code: 22000,
        //         },
        //         {
        //             icon: "mdi-pill-multiple",
        //             title: "إدارة الادواية",
        //             link: "/medicines",
        //             code: 19000,
        //         },
        //         {
        //             icon: "mdi-store-clock-outline",
        //             title: "إدارة طلبات الشراء",
        //             link: "/purchaseOrders",
        //             code: 20000,
        //         },
        //         {
        //             icon: "mdi-store-check-outline",
        //             title: "إدارة المخزون",
        //             link: "/inventory",
        //             code: 21000,
        //         },
        //         {
        //             icon: "mdi-swap-horizontal",
        //             title: "نقل المخزون",
        //             link: "/stockTransfers",
        //             code: 25000,
        //         },
        //         {
        //             icon: "mdi-order-bool-descending-variant",
        //             title: "طلبات الصرف ",
        //             link: "/dispenseRequests",
        //             code: 26000,
        //         },   

        //     ],

        // },
        {
            icon: "mdi-cog-outline",
            title: "الاعدادات",
            group: "settings",
            codes: [13000, 14000, 15000, 18000, 16000, 29000],

            subNavs: [
                // {
                //     icon: "mdi-needle",
                //     title: "ادارة التحاليل",
                //     link: "/analysis",
                //     code: 23000,
                // }, 
                {
                    icon: "mdi-bank",
                    title: "الحسابات المالية",
                    link: "/paymentAccounts",
                    code: 29000,
                },

                {
                    icon: "mdi-domain",
                    title: "الاقسام",
                    link: "/departments",
                    code: 13000,
                },
                {
                    icon: "mdi-domain",
                    title: "التخصصات",
                    link: "/specializations",
                    code: 14000,
                },

                // {
                //     icon: "mdi-account-wrench-outline",
                //     title: "الخدمات",
                //     link: "/services",
                //     code: 15000,
                // },
                {
                    icon: "mdi-account-group-outline",
                    title: "المستخدمين ",
                    link: "/users",
                    code: 18000,
                },
                {
                    icon: "mdi-list-box-outline",
                    title: "اسباب المراجعات ",
                    link: "/reviewsReasons",
                    code: 16000,
                },
                {
                    icon: "mdi-list-status",
                    title: "النصائح و الارشادات  ",
                    link: "/instructions",
                    code: 16000,
                },
            ],

        },
        {
            icon: "mdi-chart-box-outline",
            title: "العمليات المالية",
            group: "reports",
            codes: [30001],

            subNavs: [
                {
                    icon: "mdi-text-box-multiple-outline",
                    title: "مستحقات الاطباء",
                    link: "/salaryDoctorsReport",
                    code: 30001,
                },
            ],

        },


    ],
};



export const getters = {
    isVisibleSideNav: (state) => state.show,
};

export const mutations = {
    setSidenavVisibility: (state, payload) => {
        state.show = payload !== undefined ? payload : !state.show;
    },
};

export const actions = {
    setSidenavVisibility: ({ commit }, payload) => {
        commit("setSidenavVisibility", payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};